import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FileUploadModule } from 'ng2-file-upload';
import { TranslateModule } from '@ngx-translate/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LeftbarComponent } from '../components/chat/leftbar/leftbar.component';
import { HeaderNavBarComponent } from '../components/header-nav-bar/header-nav-bar.component';
import { FeatureFlagPipe } from '../common/pipes/feature-flag.pipe';
import { MediaUrlPipe } from '../pipes/media-url.pipe';

/**
 * Shared declarations used by both the eager AppModule and lazy feature
 * modules. Declares and exports the components/pipes that appear in more than
 * one module scope: `<chat-leftbar>`, `<app-header-nav-bar>` and the
 * `| featureFlag` pipe.
 *
 * The modules imported here are the ones its declared components' templates
 * depend on (`ng2FileSelect`, `formGroup`/`formControlName`/`ngModel`, the
 * `translate` pipe, `ngbPopover`, `*ngIf`). They are intentionally NOT
 * re-exported: every consumer module imports the directives it actually needs
 * itself, keeping dependencies explicit.
 *
 * Services injected by these components (ChatService, ClinicService, LabService,
 * CommonUiService, FeatureFlagService, ToastrService, ...) are provided at the
 * root injector and are therefore available to lazy modules that import this
 * SharedModule without any extra provider wiring.
 */
@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, FileUploadModule, TranslateModule, NgbModule],
  declarations: [LeftbarComponent, HeaderNavBarComponent, FeatureFlagPipe, MediaUrlPipe],
  exports: [LeftbarComponent, HeaderNavBarComponent, FeatureFlagPipe, MediaUrlPipe]
})
export class SharedModule {}
